export type TURLQueryParams = { [key: string]: any };

/**
 * Filters out non string or non number types
 */
const filterURLSearchParams = (urlQueryParameters?: TURLQueryParams): Array<[string, string]> =>
  Object.entries(urlQueryParameters || {}).filter(
    ([, value]) => typeof value === 'string' || typeof value === 'number',
  );

/**
 * Converts a key value object into a url search param string.
 */
const getURLQueryString = (urlQueryParameters?: TURLQueryParams): string => {
  const filteredUrlSearchParams: Array<[string, string]> = filterURLSearchParams(urlQueryParameters);

  if (filteredUrlSearchParams.length === 0) {
    return '';
  }

  return `?${new URLSearchParams(filteredUrlSearchParams)}`;
};

export default getURLQueryString;
